"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const expire_1 = __importDefault(require("store/plugins/expire"));
const store_engine_1 = __importDefault(require("store/src/store-engine"));
const cookieStorage_1 = __importDefault(require("store/storages/cookieStorage"));
const localStorage_1 = __importDefault(require("store/storages/localStorage"));
const memoryStorage_1 = __importDefault(require("store/storages/memoryStorage"));
// biome-ignore lint/suspicious/noExplicitAny: exception
const storeIsEqual = () => {
    return {
        // biome-ignore lint/suspicious/noExplicitAny: exception
        set(superFn, key, value) {
            const oldValue = this.get(key);
            if (oldValue === value) {
                return;
            }
            return superFn();
        },
    };
};
// biome-ignore lint/style/noDefaultExport: not changing this
exports.default = store_engine_1.default.createStore([
    localStorage_1.default,
    // Fallbacks
    cookieStorage_1.default,
    memoryStorage_1.default,
], [expire_1.default, storeIsEqual]);
//# sourceMappingURL=storage.js.map